module.exports = __webpack_public_path__ + "img/admin.068680d9.png";